/**
 * Utility module: getTeams/getQualifiedTeams.js.
 */

const KNOCKOUT_STAGE = 'Last 16';

/**
 * Retrieves the qualified team codes from the given matches based on knockout
 * stage participation.
 * @param {Array} matches - The array of matches.
 * @returns {string[]} - Unique array of qualified team codes.
 */
export default (matches) => {
  if (!Array.isArray(matches)) return [];

  const codes = new Set();

  for (const match of matches) {
    const stageName = match?.matchInfo?.stage?.name;
    if (stageName !== KNOCKOUT_STAGE) continue;

    const contestants = match?.matchInfo?.contestant;
    if (!Array.isArray(contestants) || contestants.length === 0) continue;

    // Skip matches whose contestants are still placeholders (e.g. "Winner Match 41")
    const hasNamedTeams = contestants.every((team) => team?.name);
    if (!hasNamedTeams) continue;

    for (const team of contestants) {
      if (team?.code) codes.add(team.code);
    }
  }

  return [...codes];
};
